/**
 * @file index.tsx
 *
 * @fileoverview Extends nextjs link component so that links have auomatically the
 * language prefix appended to them.
 */
import Link from 'next/link';
import React, { cloneElement, memo, useContext } from 'react';
import { AppContext } from '~/jobiqo/context/app';
import { AppContextInterface } from '~/jobiqo/models/app';
import { getTranslatedLink } from '~/jobiqo/utils/links';

const CustomLink = memo(function ({ href, asChild, children, ...props }: any) {
  const { locale }: AppContextInterface = useContext(AppContext);
  let translatedHref =
    asChild && children.props.href ? children.props.href : href;

  if (locale && typeof href === 'string') {
    translatedHref = getTranslatedLink(href, locale);
  }

  // For external links, use <a/> element.
  if (translatedHref.startsWith?.('http')) {
    // If asChild is true, clone the child element and update its props.
    if (asChild) {
      return cloneElement(children, {
        target: '_blank',
        rel: 'noreferrer',
        href: translatedHref,
      });
    }
    return (
      <a {...props} href={translatedHref} target="_blank" rel="noreferrer">
        {children}
      </a>
    );
  } else {
    // For internal links, use next/link - <Link />.
    if (asChild) {
      return cloneElement(children, {
        // Use the href from the child
        href: children.props.href || translatedHref,
      });
    }
    return (
      <Link {...props} href={translatedHref}>
        {children}
      </Link>
    );
  }
});
export default CustomLink;
